import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userreqhoroslist, updateuserhorosreq } from "../action/user";
import swal from "sweetalert";

export default function MoreinfoRequests() {
  const history = useNavigate();

  // State to manage request statuses
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const statusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    // { value: "Deleted", label: "Deleted" },
  ];

  // Fetch horoscope requests from API
  const fetchRequests = async () => {
    try {
      setLoading(true);
      const response = await userreqhoroslist();
      console.log("API Response:", response);

      if (response?.userValue?.length > 0) {
        setRequests(response.userValue);
      } else {
        setRequests([]);
      }
    } catch (error) {
      console.error("Error fetching profile requests:", error);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleStatusChange = async (requestId, newStatus) => {
    const action = newStatus === "Approved" ? "approve" : "reject";
    const icon = newStatus === "Approved" ? "success" : "warning";
    const title = newStatus === "Approved" ? "Approve Request?" : "Reject Request?";
    const text = `Are you sure you want to ${action} this profile view request?`;

    const confirm = await swal({
      title,
      text,
      icon,
      buttons: ["Cancel", `Yes, ${action === "approve" ? "Approve" : "Reject"}`],
      dangerMode: newStatus === "Rejected",
    });

    if (!confirm) return;

    try {
      await updateuserhorosreq(requestId, newStatus); // Send new status to backend
      await fetchRequests();
      swal("Success!", `Request has been ${newStatus.toLowerCase()}.`, "success");
    } catch (err) {
      swal("Error", "Failed to update request. Please try again.", "error");
    }
  };

  // Format Date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const getAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  };

  return (
    <>
      <div className="agent-payment-container">
        <h2 className="font-great-vibes" style={{ margin: "0px 20px 20px", color: "#B21919" }}>
          Profile View Requests Received
        </h2>

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px", fontSize: "18px", color: "#666" }}>
            Loading requests...
          </div>
        ) : (
          <table className="payment-table">
            <thead>
              <tr>
                <th>User ID</th>
                <th>Name</th>
                <th>Age</th>
                {/* <th>Religion</th> */}
                <th>Requested On</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((req) => {
                const user = req.user_id || {};
                const currentStatus = req.status;

                return (
                  <tr key={req._id}>
                    <td>
                      <a href={"/batman/" + user.id}>
                        {user.userid || "N/A"}
                      </a>
                    </td>
                    <td style={{ textAlign: "left" }}>{user.mname || "N/A"}</td>
                    <td>{user.dob ? getAge(user.dob) : "N/A"}</td>
                    <td>{formatDate(req.createdAt)}</td>

                    {/* Status Badge */}
                    <td>
                      <span
                        className="status-badge"
                        style={{
                          backgroundColor:
                            currentStatus === "Approved"
                              ? "#d4edda"
                              : currentStatus === "Rejected"
                                ? "#f8d7da"
                                : "#fff3cd",
                          color:
                            currentStatus === "Approved"
                              ? "#1a8735"
                              : currentStatus === "Rejected"
                                ? "#c82333"
                                : "#ff8f00",
                        }}
                      >
                        {currentStatus}
                      </span>
                    </td>

                    <td>
                      {currentStatus === "Pending" ? (
                        <select
                          onChange={(e) => handleStatusChange(req._id, e.target.value)}
                          style={{
                            padding: "8px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            backgroundColor: "white",
                            fontSize: "14px",
                            cursor: "pointer",
                            minWidth: "120px",
                          }}
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select Action
                          </option>
                          {statusOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span style={{ color: "#888", fontStyle: "italic" }}>
                          Action Taken
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <style jsx>{`
        .agent-payment-container {
          background: #ffecd6;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
          margin: 20px;
        }

        .payment-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 10px;
          margin-top: 15px;
          font-size: 18px;
          overflow: hidden;
          border-radius: 10px;
        }

        .payment-table thead tr th {
          text-align: center;
          padding: 14px;
          background: #b21919;
          color: white;
          font-size: 20px;
          font-weight: 600;
        }

        .payment-table thead tr th:first-child {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }

        .payment-table thead tr th:last-child {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }

        .payment-table tbody tr {
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          background: white;
        }

        .payment-table tbody tr:hover {
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .payment-table td {
          padding: 16px 12px;
          text-align: center;
          font-size: 16px;
        }

        /* Status Badge */
        .status-badge {
          padding: 6px 14px;
          font-size: 14px;
          border-radius: 20px;
          font-weight: 600;
          text-transform: capitalize;
          display: inline-block;
          min-width: 90px;
        }

        .status-badge.success {
          color: #1a8735;
          background-color: #d4edda;
        }

        .status-badge.failed {
          color: #c82333;
          background-color: #f8d7da;
        }

        .status-badge.open {
          color: #ff8f00;
          background-color: #fff3cd;
        }

        .no-data {
          text-align: center;
          padding: 30px;
          color: #999;
          font-style: italic;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .payment-table {
            font-size: 16px;
          }
          .payment-table th,
          .payment-table td {
            padding: 10px 8px;
            font-size: 14px;
          }
          .status-badge {
            font-size: 12px;
            padding: 4px 10px;
            min-width: 70px;
          }
        }
      `}</style>
    </>
  );
}
